/* eslint-disable import/extensions */
/* eslint-disable no-shadow */
import React from "react";

// eslint-disable-next-line import/extensions
import { Container } from "./styles";
import AllAllocationsActivities from "./AllAllocationsActivities";

const Allocations: React.FC = () => {
  return (
    <Container>
      <AllAllocationsActivities />
    </Container>
  );
};

export default Allocations;
